import { Deserializable } from '../../../../protocols/deserializable';
import { Address } from '../../../../users/dto/address';

export class UpdateEmployerAddressSubmissionData implements Deserializable {
  public headOfficeAddress!: Address;
  public mailingAddress!: Address;

  public onDeserialize(): void {
    if (!!this.headOfficeAddress) {
      this.headOfficeAddress = window.injector.Deserialize.instanceOf(Address, this.headOfficeAddress);
    }
    if (!!this.mailingAddress) {
      this.mailingAddress = window.injector.Deserialize.instanceOf(Address, this.mailingAddress);
    }
  }
}
